import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GameSettingsComponent } from "./game-settings.component";
import { RouterModule } from "@angular/router";
import { MaterialModule } from "@app/material/material.module";
import { QRCodeModule } from 'angularx-qrcode';
import { FlexLayoutModule } from "@angular/flex-layout";
import { FuseSharedModule } from "@fuse/shared.module";
import { FuseConfirmDialogModule, FuseWidgetModule } from "@fuse/components";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from "ng-pick-datetime";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SortablejsModule } from "angular-sortablejs";
import { MaterialFileInputModule } from "ngx-material-file-input";
import { PrizeFormComponent } from "./prize-form/prize-form.component";
import {
  MatDialogModule,
  MatDividerModule,
  MatFormFieldModule,
  MatInputModule,
  MatTooltipModule,
} from "@angular/material";
import { AuthGuard } from "@app/auth/auth.guard";
import { NgxPaginationModule } from "ngx-pagination";
import { HttpClientModule } from "@angular/common/http";
import { GameSettingsService } from "@app/main/content/game-settings/game-settings.service";
import { PlayerListingComponent } from "./player-listing/player-listing.component";
import { AdFormComponent } from "./ad-form/ad-form.component";
import { PopupModule } from "@app/main/content/game-settings/popup/popup.module";
import { ContentModule } from "@app/main/content/game-settings/popup/content/content.module";
import { InviteImageArtComponent } from "./invite-image-art/invite-image-art.component";
import { InviteImageColorGradientComponent } from "./invite-image-art/invite-image-color-gradient/invite-image-color-gradient.component";
import { SurveyComponent } from "./ad-form/survey/survey.component";
import { LocationComponent } from "./location/location.component";
import { AgmCoreModule } from "@agm/core";
import { environment } from "@env/environment";
import { AllEmojisContainerComponent } from "./all-emojis-container/all-emojis-container.component";
import { AllScreensContainerComponent } from './all-screens-container/all-screens-container.component';
import { GameMenuArtPreviewComponent } from './game-menu-art-preview/game-menu-art-preview.component';
import { ColorWheelSelectionComponent } from './color-wheel-selection/color-wheel-selection.component';
import { NewEmojiCountdownPopupComponent } from './new-emoji-countdown-popup/new-emoji-countdown-popup.component';
import { ReactiveFormsModule } from "@angular/forms";
import { CustomCountComponent } from './new-emoji-countdown-popup/custom-count/custom-count.component';
import { ColorConfettiComponent } from './prize-form/color-confetti/color-confetti.component';
import { EmojiConfettiComponent } from './prize-form/emoji-confetti/emoji-confetti.component';
import { CountdownTimerModule } from "ngx-countdown-timer";
import { SimilarGamesComponent } from './similar-games/similar-games.component';
import { TieBreakerScreenColorsComponent } from './tie-breaker-screen-colors/tie-breaker-screen-colors.component';
import { CashPrizeImagesComponent } from './exact-match-editor/cash-prize-images/cash-prize-images.component';
import { MatchEditorComponent } from './exact-match-editor/match-editor/match-editor.component';
import { ScreenEmojisComponent } from './exact-match-editor/screen-emojis/screen-emojis.component';
import { CashPrizeImageUploadComponent } from './exact-match-editor/cash-prize-image-upload/cash-prize-image-upload.component';
import { CanvasConfettiComponent } from './prize-form/canvas-confetti/canvas-confetti.component';
import { QrCodePreviewComponent } from './qr-code-preview/qr-code-preview.component';
import { RewardSelectorComponent } from './reward-selector/reward-selector.component';
import { TranslatableTextInputComponent } from "./translatable-text-input/translatable-text-input.component";
import { TranslatableTextTranslationsDialogComponent } from "./translatable-text-input/translatable-text-translations-dialog/translatable-text-translations-dialog.component";
import { RewardInfoComponent } from './reward-selector/reward-info/reward-info.component';
import { ColorSettingComponent  } from './shared/components/color-toggle/color-toggle.component';
import { ImageControlComponent } from './shared/components/image-control/image-control.component';
import { RewardEditorComponent } from './reward-selector/reward-info/reward-editor/reward-editor.component';
import { RegistrationFormDialogComponent } from "./shared/components/registration-form/dialog/registration-form-dialog.component";
import { RegistrationButtonComponent } from "./shared/components/registration-form/button/registration-button.component";
import { ImageEditorModule } from "./shared/components/image-editor/image-editor.module";
import { GameAssetsSettingsComponent } from "./shared/components/game-assets-settings/game-assets-settings.component";
import { GameAssetPreviewComponent } from "./shared/components/game-asset-preview/game-asset-preview.component";
import { SubmittedEmojisPreviewComponent } from "./shared/components/submitted-emojis-preview/submitted-emojis-preview.component";
import { AutomatchSelfpickArtComponent } from './automatch-selfpick-art/automatch-selfpick-art.component';
import { DressUpConfigComponent } from './dress-up-config/dress-up-config.component';

const routes = [
  {
    path: "game/new",
    component: GameSettingsComponent,
    canActivate: [AuthGuard],
    resolve: {
      data: GameSettingsService,
    },
  },
  {
    path: "game/edit/:id",
    component: GameSettingsComponent,
    canActivate: [AuthGuard],
    resolve: {
      data: GameSettingsService,
    },
  },
  {
    path: "game/restart/:id",
    component: GameSettingsComponent,
    canActivate: [AuthGuard],
    resolve: {
      data: GameSettingsService,
    },
  },
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FuseConfirmDialogModule,
    RouterModule.forChild(routes),
    FlexLayoutModule,
    MaterialModule,
    FuseSharedModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    BrowserAnimationsModule,
    SortablejsModule.forRoot({ animation: 150 }),
    MaterialFileInputModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    NgxPaginationModule,
    HttpClientModule,
    QRCodeModule,

    PopupModule,
    ContentModule,
    ImageEditorModule,

    CountdownTimerModule.forRoot(),
    FuseWidgetModule,

    FuseSharedModule,

    AgmCoreModule.forRoot({
      apiKey: environment.googleApiKey,
      libraries: ["places"],
    }),
  ],
  exports: [
    NewEmojiCountdownPopupComponent
  ],
  declarations: [
    GameSettingsComponent,
    TranslatableTextInputComponent,
    TranslatableTextTranslationsDialogComponent,
    PrizeFormComponent,
    PlayerListingComponent,
    AdFormComponent,
    InviteImageArtComponent,
    InviteImageColorGradientComponent,
    SurveyComponent,
    LocationComponent,
    AllEmojisContainerComponent,
    AllScreensContainerComponent,
    GameMenuArtPreviewComponent,
    ColorWheelSelectionComponent,
    NewEmojiCountdownPopupComponent,
    CustomCountComponent,
    ColorConfettiComponent,
    EmojiConfettiComponent,
    SimilarGamesComponent,
    TieBreakerScreenColorsComponent,
    CashPrizeImagesComponent,
    MatchEditorComponent,
    ScreenEmojisComponent,
    CashPrizeImageUploadComponent,
    CanvasConfettiComponent,
    QrCodePreviewComponent,
    RewardSelectorComponent,
    RewardInfoComponent,
    ColorSettingComponent,
    ImageControlComponent,
    GameAssetsSettingsComponent,
    RewardEditorComponent,
    RegistrationFormDialogComponent,
    RegistrationButtonComponent,
    GameAssetPreviewComponent,
    SubmittedEmojisPreviewComponent,
    AutomatchSelfpickArtComponent,
    DressUpConfigComponent
  ],
  entryComponents: [
    TranslatableTextTranslationsDialogComponent,
    PrizeFormComponent,
    PlayerListingComponent,
    AdFormComponent,
    CustomCountComponent,
    MatchEditorComponent,
    RewardInfoComponent,
    RegistrationFormDialogComponent
  ],
  providers: [GameSettingsService],
})
export class GameSettingsModule {}
